import { render, staticRenderFns } from "./ProductManager.vue?vue&type=template&id=07a594ca&scoped=true"
import script from "./ProductManager.vue?vue&type=script&lang=js"
export * from "./ProductManager.vue?vue&type=script&lang=js"
import style0 from "./ProductManager.vue?vue&type=style&index=0&id=07a594ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a594ca",
  null
  
)

export default component.exports